// Whether this tab shows a room's userlist. It decides whether the socket
// server sends userlist changes (chat_focus, and userlist_visible on connect)
// and whether chat/userlist is fetched.
//
// The legacy layout decides from its toggles, which are saved in localStorage.
// The netplay People column counts as visible whenever it is shown (docked or
// opened as an overlay), whatever those toggles say. Off the netplay page the
// only chat is the dock's (react/dock/chat), which shows no userlist.

import { isNetplayPageActive } from 'react/netplay/netplayPageState';

let shownPeopleColumns = 0;
const listeners = new Set();

function notify() {
	listeners.forEach((listener) => listener());
}

/** Call when a People column shows; returns the function to call when it hides. */
export function showPeopleColumn() {
	shownPeopleColumns++;
	notify();
	let hidden = false;
	return () => {
		if(hidden) {
			return;
		}
		hidden = true;
		shownPeopleColumns--;
		notify();
	};
}

export function onUserlistVisibilityChange(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

function peopleColumnIsShown() {
	return shownPeopleColumns > 0;
}

/** For chat/userlist fetches and the socket's userlist_visible on connect. */
export function userlistIsVisibleForFetch(chatState) {
	if(!isNetplayPageActive()) {
		return false;
	}
	return peopleColumnIsShown() || !!(chatState.mainChatUserlistToggledOn && chatState.chatLargeToggledOn);
}

/** For chat_focus, which also counts the legacy userlist sidebar. */
export function userlistIsVisibleForFocus(chatState) {
	return userlistIsVisibleForFetch(chatState) || (isNetplayPageActive() && !!chatState.chatUserlistSidebarOpen);
}
